
export const montessori = {
  title: "Montessori Education",
  bookVisit: "Schedule a visit",
  intro: {
    description: "Our approach is inspired by Montessori methodology, combined with our own educational vision that integrates nature, trilingualism, and respectful accompaniment. At Gándara International School, we believe in the Montessori philosophy as the foundation of our educational project. This pedagogical approach, developed by Dr. Maria Montessori over a century ago, remains revolutionary in its understanding of child development and its respect for each child as a unique individual."
  },
  principles: {
    environment: {
      title: "Prepared Environment",
      description: "We create carefully designed spaces that invite exploration and self-directed learning, with materials adapted to each stage of development."
    },
    accompaniment: {
      title: "Respectful Accompaniment",
      description: "Our Montessori guides observe and support each child's natural learning process, providing assistance when needed while respecting their autonomy."
    },
    learning: {
      title: "Active Learning",
      description: "Children construct their knowledge through manipulation, experimentation, and discovery, developing a deep understanding of concepts."
    },
    nature: {
      title: "Connection with Nature",
      description: "We encourage direct contact with the natural environment as a source of learning, well-being, and ecological awareness development."
    },
    autonomy: {
      title: "Development of Autonomy",
      description: "We cultivate independence and decision-making skills, allowing children to be the protagonists of their own learning journey."
    },
    coexistence: {
      title: "Community and Coexistence",
      description: "We promote relationships based on mutual respect, collaboration, and peaceful conflict resolution within our learning community."
    }
  },
  space: {
    title: "Our Space",
    description1: "Gándara is located in a privileged environment that combines nature and proximity to the urban center of Vigo.",
    description2: "Our facilities are specifically designed to facilitate Montessori learning, with bright, orderly spaces adapted to children's needs.",
    description3: "Each classroom is a prepared environment where materials are organized logically and accessibly, inviting autonomous activity and discovery.",
    property: "A property of more than 5,000 m² with extensive green areas, a school garden, and outdoor play areas",
    facilities: "Welcoming indoor spaces with high-quality Montessori materials",
    location: "Strategic location: 10 minutes from the center of Vigo with easy access from the AP-9"
  },
  classrooms: {
    title: "Montessori Classrooms",
    description: "Our prepared environments are designed to foster autonomy, exploration, and active learning at each stage of development."
  },
  infantil: {
    title: "Early Years (Ages 3-6)",
    description: "In the early years stage, children work in a prepared environment with Montessori materials that invite sensory exploration, language development, and early mathematical concepts.",
    classroom: "The early years classroom is a bright, orderly space where each material has its place. Children freely choose their activities and work at their own pace, accompanied by guides trained in Montessori methodology."
  },
  primary: {
    title: "Primary (Ages 6-12)",
    description: "The primary stage is divided into two cycles: Workshop 1 (ages 6-9) and Workshop 2 (ages 9-12). Children work on interdisciplinary projects that connect areas of knowledge and encourage research.",
    classroom: "In primary, learning extends beyond the classroom. Research projects, outings to the natural environment, and cooperative work form the basis of our educational approach."
  },
  nature: {
    title: "Nature and Active Learning",
    description: "At Gándara, nature is not just a setting: it is a pedagogical tool. Our more than 5,000 m² property offers a vegetable garden, gardens, and green spaces where children learn natural sciences through hands-on experience, develop motor skills, and connect with the cycles of life."
  }
};
